/* src/app/app.component.scss */
.loader-container {
  z-index: 9999;
  position: relative;
  pointer-events: none;
}
.loader-container.show {
  pointer-events: all;
}
.maintenance-overlay {
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}
.maintenance-box {
  background: #fff;
  padding: 30px 40px;
  border-radius: 10px;
  text-align: center;
  max-width: 400px;
}
/*# sourceMappingURL=app.component-2P5L3NMD.css.map */
